export const BORDER_RADIUS_LARGE = '16px';
export const BORDER_RADIUS_MEDIUM = '12px';
export const BORDER_RADIUS_SMALL = '8px';
export const BORDER_RADIUS_EXTRA_SMALL = '4px';
